(function ($) {
    /***
     * 产品页面需求
     */
    'use strict';

    const handleNoUsUser = function () {
        const US_CODE = 'US';
        __MakeBlock_Utils.discernIp().then((res) => {
            if (res.country_iso_code !== US_CODE) {
                $('#no-use-user').removeClass('section-hide');
                // if ($('.education-user').length>0) $('.education-user').addClass('section-hide');
                // if ($('.personal-user').length>0) $('.personal-user').addClass('section-hide');
                // $('.product-page-info__button-add-to-cart').hide();
                // $('.product-page-info__dynamic-checkout').parent().parent().hide();
                // $('.product-page-info__quantity').hide();
                // $('.product-page-info__payments').removeClass('d-flex').hide();
                // $('.p-policy-content').hide();
                // __MakeBlock_Utils.observeStyleChanges(document.querySelector('#footbar-product-wrapper'), () => { 
                //     $('#footbar-product-wrapper').css({ display: 'none !important'}); });
            } else {
                $('#no-use-user').addClass('section-hide');
                // if ($('.education-user').length>0) $('.education-user').removeClass('section-hide');
                // if ($('.personal-user').length>0) $('.personal-user').removeClass('section-hide');
                // $('.product-page-info__button-add-to-cart').show();
                // $('.product-page-info__dynamic-checkout').parent().parent().show();
                // $('.product-page-info__quantity').show();
                // $('.product-page-info__payments').addClass('d-flex');
                // $('.p-policy-content').show();
            }
        });

    }

    class CopydiscontCode extends HTMLElement {

    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('copy-discontcode', CopydiscontCode);
    });

    theme.AssetsLoader.onPageLoaded(function () {
        handleNoUsUser();
    });
})(jQueryTheme);